import React from 'react';
import * as Routes from '@/modules/routes';
import useGradesTableStore from '../store/useGradesTableStore';
import AssignmentsRow from './Rows/AssignmentsRow';
import StudentRow from './Rows/StudentsRow';
import Legend from './Legend';
import styles from './styles.module.scss';
import Spinner from '../../../common/Modal/Spinner';

const Table = () => {
  const students = useGradesTableStore(state => state.students);
  const classroom = useGradesTableStore(state => state.classroom);
  const programId = useGradesTableStore(state => state.programId);
  const isLoading = useGradesTableStore(state => state.isLoading());

  if (isLoading) return (<Spinner isLoading={isLoading} />);

  if (students.length < 1) {
    const url = Routes.new_teacher_classroom_student_path(classroom.id, { program_id: programId });

    return (
      <div className="tw-mt-12">
        <p className="tw-mb-3"> You have a studentless classroom! Click Add Students to finish creating your class </p>
        <a className="btn btn--green" href={url}> Add Students </a>
      </div>
    );
  }

  return (
    <figure>
      <div className={styles.assignmentsGradesTableWrapper}>
        <table className={styles.assignmentsGradesTable}>
          <thead>
            <AssignmentsRow />
          </thead>
          <tbody>
            {students.map(student => (
              <StudentRow
                key={`student-row-${student.id}`}
                student={student}
              />
            ))}
          </tbody>
        </table>
      </div>
      <figcaption>
        {students.length > 0 && <Legend />}
      </figcaption>
    </figure>
  );
};

export default Table;
